import lodash from 'lodash'
import Base from '../base.store'

const baseUrl = '/api/v1/transaction/certificate-requests'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        cloneCertificateRequest(context, { data, config }){
            return base.request.post(`${baseUrl}/clone-certificate-request`, data, { ...config });
        },
        searchAllByRefCompanyId(context, { criteria, config, searchQuery, where = [], refCompanyId }){
            const wheres = [
                { name: "isActive", type: "Boolean", operator: '=', value: true },
                { name: "refRequestStatus.key", type: "String", operator: 'in', value: ['Pending Review', 'Wait Approve', 'Approve', 'Wait Print', 'Printed'] },
                { name: "refCompany.id", type: "UUID", operator: '=', value: refCompanyId },
                { name: "isTmp", type: "Boolean", operator: '=', value: false }
            ]
            if (searchQuery) {
                wheres.push({ name: "requestNo", type: 'String', operator: 'like', value: searchQuery })
            }
            criteria = lodash.merge({
                select: ['**', 'refCompany.refFactoryAddrEn.**'],
                page: 0,
                size: 100,
                sort: [{ name: "requestNo", type: "DESC" }],
                where: [...wheres, ...where],
                children: [
                    { name: 'attachments', select: ['*'], page: 0, size: 1000000},
                    { name: 'farmLocations', select: ['*', 'refParent.*'], page: 0, size: 1000000},
                    { name: 'aquaticScientificNames', select: ['**', 'refParent.*'], page: 0, size: 1000000},
                    {
                        name: 'certificateProducts',
                        select: [
                            '**',
                            'refCompanyProduct.refProduct.*',
                            'refCompanyProduct.refProduct.refProductType.*',
                            'refSamplingProduct.*',
                            'refSamplingProduct.refExportAmountUnit.*',
                            'refSamplingProduct.refCompanyProduct.*',
                            'refSamplingProduct.refCompanyProduct.refProduct.*',
                            'refSamplingProduct.refCompanyProduct.refProductType.*',
                            'refSamplingProduct.refCountry1.refCountry.*',
                            'refSamplingProduct.refCountry2.refCountry.*',
                            'refParent.**',
                            'refParent.refCompanyProduct.refProduct.*',
                            'refParent.refCompanyProduct.refProduct.refProductType.*',
                            'refParent.refSamplingProduct.*',
                            'refParent.refSamplingProduct.refExportAmountUnit.*',
                            'refParent.refSamplingProduct.refCompanyProduct.*',
                            'refParent.refSamplingProduct.refCompanyProduct.refProduct.*',
                            'refParent.refSamplingProduct.refCompanyProduct.refProductType.*',
                            'refParent.refSamplingProduct.refCountry1.refCountry.*',
                            'refParent.refSamplingProduct.refCountry2.refCountry.*'
                        ],
                        page: 0,
                        size: 1000000, },
                ]
            }, criteria)
            return context.dispatch('search', { criteria, config })
                .then(page => {
                    const list = page.data
                    return list
                });
        },
        findChildrenByIdAndRequestNo(context, { criteria, config, requestNo, id, where = []}) {
            const wheres = [
                { name: "isActive", type: "Boolean", operator: '=', value: true },
                { name: "isTmp", type: "Boolean", operator: '=', value: true },
                { name: "refParent.id", type: "UUID", operator: '=', value: id },
                { name: "requestNo", type: 'String', operator: '=', value: requestNo },
            ]
            criteria = lodash.merge({
                select: ['**'],
                page: 0,
                size: 100,
                sort: [{ name: "requestNo", type: "DESC" }],
                where: [...wheres, ...where],
            }, criteria)
            return context.dispatch('search', { criteria, config })
                .then(page => {
                    const list = page.data
                    return list
                });
        },
    },
    mutations: {
        ...base.mutations
    },
}
